/* eslint-disable react-hooks/exhaustive-deps */
import {
  FilterTypes,
  type IFilter,
} from "@/api/AppApi/services/filters/interfaces/IGetFilters";
import { IProductChildMinimizedData } from "./helpers/interfaces";
import ColorFilter from "@/app/components/common-filter-builder/filter/filter-components/ColorFilter";
import DropDownFilter from "@/app/components/common-filter-builder/filter/filter-components/DropDownFilter";
import PriceRager from "@/app/components/common-filter-builder/filter/filter-components/PriceRager";
import SelectButtons from "@/app/components/common-filter-builder/filter/filter-components/SelectButtons";
import SelectImages from "@/app/components/common-filter-builder/filter/filter-components/SelectImages";
import SelectOption from "@/app/components/common-filter-builder/filter/filter-components/SelectOption";
import TagsFilter from "@/app/components/common-filter-builder/filter/filter-components/TagsFilter";

interface IAttributesBuilder {
  productChildren: IProductChildMinimizedData[];
  attribute: IFilter;
  state: string[];
  setState: (state: string[]) => void;
  unAvailabeKeys?: string[];
  outOfStockKeys?: string[];
  attributesMaxWidth?: number;
  isProductBox?: boolean;
  allow_user_request_stock_availability_reminder?: boolean;
}
const ProductAttributesBuilder: React.FC<IAttributesBuilder> = ({
  attribute,
  state,
  setState,
  unAvailabeKeys = [],
  outOfStockKeys = [],
  productChildren,
  attributesMaxWidth,
  isProductBox,
  allow_user_request_stock_availability_reminder,
}) => {
  if (attribute.data?.length === 1) return null;
  if (isProductBox) {
    switch (attribute.configurations.type) {
      case FilterTypes.color_selector:
        return (
          <ColorFilter
            sliderMaxWidth={attributesMaxWidth}
            filter={attribute}
            state={state}
            setState={setState}
            unAvailabeKeys={unAvailabeKeys}
            outOfStockKeys={outOfStockKeys}
            isProductBox
          />
        );
      case FilterTypes.images:
        return (
          <SelectImages
            filter={attribute}
            state={state}
            setState={setState}
            unAvailabeKeys={unAvailabeKeys}
            outOfStockKeys={outOfStockKeys}
            productChildren={productChildren}
            sliderMaxWidth={attributesMaxWidth}
            isProductBox
          />
        );
      case FilterTypes.carousel:
      case FilterTypes.checkbox:
      case FilterTypes.tags:
      case FilterTypes.dropdown:
        return (
          <SelectButtons
            filter={attribute}
            state={state}
            setState={setState}
            unAvailabeKeys={unAvailabeKeys}
            outOfStockKeys={outOfStockKeys}
            isProductBox
          />
        );

      case FilterTypes.range_slider:
        return (
          <PriceRager filter={attribute} state={state} setState={setState} />
        );
      default:
        return null;
    }
  }
  switch (attribute.configurations.type) {
    case FilterTypes.carousel:
      return (
        <SelectButtons
          filter={attribute}
          state={state}
          setState={setState}
          unAvailabeKeys={unAvailabeKeys}
          outOfStockKeys={outOfStockKeys}
          allow_user_request_stock_availability_reminder={
            allow_user_request_stock_availability_reminder
          }
        />
      );
    case FilterTypes.color_selector:
      return (
        <ColorFilter
          sliderMaxWidth={attributesMaxWidth}
          filter={attribute}
          state={state}
          setState={setState}
          unAvailabeKeys={unAvailabeKeys}
          outOfStockKeys={outOfStockKeys}
          allow_user_request_stock_availability_reminder={
            allow_user_request_stock_availability_reminder
          }
        />
      );
    case FilterTypes.checkbox:
      return (
        <SelectOption
          filter={attribute}
          state={state}
          setState={setState}
          unAvailabeKeys={unAvailabeKeys}
          outOfStockKeys={outOfStockKeys}
          allow_user_request_stock_availability_reminder={
            allow_user_request_stock_availability_reminder
          }
        />
      );
    case FilterTypes.tags:
      return (
        <TagsFilter
          filter={attribute}
          state={state}
          setState={setState}
          unAvailabeKeys={unAvailabeKeys}
          outOfStockKeys={outOfStockKeys}
          allow_user_request_stock_availability_reminder={
            allow_user_request_stock_availability_reminder
          }
        />
      );
    case FilterTypes.range_slider:
      return (
        <PriceRager filter={attribute} state={state} setState={setState} />
      );
    case FilterTypes.dropdown:
      return (
        <DropDownFilter
          filter={attribute}
          state={state}
          setState={setState}
          unAvailabeKeys={unAvailabeKeys}
          outOfStockKeys={outOfStockKeys}
          allow_user_request_stock_availability_reminder={
            allow_user_request_stock_availability_reminder
          }
        />
      );
    case FilterTypes.images:
      return (
        <SelectImages
          filter={attribute}
          state={state}
          setState={setState}
          unAvailabeKeys={unAvailabeKeys}
          outOfStockKeys={outOfStockKeys}
          productChildren={productChildren}
          sliderMaxWidth={attributesMaxWidth}
          allow_user_request_stock_availability_reminder={
            allow_user_request_stock_availability_reminder
          }
        />
      );

    default:
      return null;
  }
};
export default ProductAttributesBuilder;
